<div class="d-flex flex-wrap flex-stack mb-6">
  <h3 class="fw-bold my-2">My Memberships</h3>
  <div class="d-flex flex-wrap my-2">
    <app-button
      [variant]="'primary'"
      [label]="'Purchase Membership'"
      [iconClass]="'fa fa-plus'"
      (clicked)="openPurchaseMembershipModal()"
    />
  </div>
</div>

@if (memberShips) {
  @for (membership of memberShips; track membership.membership_id) {
    <div class="row d-flex">
      <div class="col-lg-12 col-12 d-flex">
        <div class="card mb-5 mb-xl-10 flex-fill" id="kt_profile_details_view">
          <div class="card-header cursor-pointer align-items-center">
            <div class="card-title m-0">
              <h3 class="fw-bold m-0">{{ membership.plan!.name }}</h3>
            </div>
            @if (membership.status == 'active') {
              <div class="card-toolbar">
                <app-button
                  [variant]="'danger'"
                  [label]="'Cancel Membership'"
                  [iconClass]="'fa fa-times'"
                  (clicked)="cancelMembership(membership)"
                />
              </div>
            }
          </div>
          <div class="card-body p-9">
            <div class="row mb-7">
              <label class="col-lg-4 fw-semibold text-muted">Plan</label>
              <div class="col-lg-8">
                <span class="fw-bold fs-6 text-gray-800">{{membership.plan!.name}}</span>
              </div>
            </div>
            <div class="row mb-7">
              <label class="col-lg-4 fw-semibold text-muted">Coverage Type</label>
              <div class="col-lg-8">
                <span class="badge" [class.badge-primary]="membership.plan!.coverage === 'individual'" [class.badge-success]="membership.plan!.coverage === 'family'">
                  {{ membership.plan!.coverage | titlecase }}
                </span>
              </div>
            </div>
            @if (membership.plan!.coverage === 'family' && membership.family) {
              <div class="row mb-7">
                <label class="col-lg-4 fw-semibold text-muted">Number of family members</label>
                <div class="col-lg-8">
                  <span class="fw-semibold fs-6 text-gray-800">{{ membership.family!.members.length}}</span>
                  @if (membership.plan!.max_children) {
                    <span class="text-muted ms-2">/ {{ membership.plan!.max_children }} max</span>
                  }
                </div>
              </div>
            }
            <div class="row mb-7">
              <label class="col-lg-4 fw-semibold text-muted">Started at</label>
              <div class="col-lg-8 fv-row">
                <span class="fw-semibold text-gray-800 fs-6">{{ formatTimeYMD(membership.started_at) }}</span>
              </div>
            </div>
            <div class="row mb-7">
              <label class="col-lg-4 fw-semibold text-muted">Expires at</label>
              <div class="col-lg-8">
                <a href="#" class="fw-semibold fs-6 text-gray-800 text-hover-primary">{{ formatTimeYMD(membership.expires_at) }}</a>
              </div>
            </div>
            <div class="row mb-7">
              <label class="col-lg-4 fw-semibold text-muted">Status</label>
              <div class="col-lg-8">
                @if (membership.status == 'active') {
                  <span class="badge badge-success">Active</span>
                } @else {
                  <span class="badge badge-dark">Inactive</span>
                }
              </div>
            </div>
            @if (membership.plan!.coverage === 'family' && membership.family) {
              <div class="separator my-5"></div>
              <div class="d-flex flex-wrap flex-stack mb-6">
                <h4 class="fw-bold my-2">Family Members</h4>
                <div class="d-flex flex-wrap my-2">
                  <app-button
                    [variant]="'primary'"
                    [label]="'Add Family Member'"
                    [iconClass]="'fa fa-plus'"
                    [disabled]="!!(membership.plan!.max_children && membership.family!.members.length >= membership.plan!.max_children)"
                    (clicked)="openMembershipModal(membership.family!.family_id)"
                  />
                </div>
              </div>
              <div class="row g-6 g-xl-9">
                @for (member of membership.family?.members; track member.user.user_id) {
                  <div class="col-md-4">
                    <div class="card">
                      <div class="card-body d-flex flex-center flex-column py-9 px-5">
                        <div class="symbol symbol-65px symbol-circle mb-5">
                          @if (member.user.profile_image_url && member.user.profile_image_url.length > 0) {
                            <img src="{{member.user.profile_image_url}}" alt="image"/>
                          } @else {
                            <img src="assets/images/blank.png" alt="image" />
                          }
                        </div>
                        <a href="#" class="fs-4 text-gray-800 text-hover-primary fw-bold">{{member.user.full_name}}</a>
                        <a href="#" class="fs-4 text-gray-800 text-hover-primary fw-semibold spacing-20">{{member.role}}</a>
                        <div class="button-container d-flex flex-row">
                          <app-button
                            [variant]="'outline'"
                            [label]="'Remove'"
                            [iconClass]="'fa fa-trash'"
                            (clicked)="removeMemberFromFamily(membership, member)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
}
